import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { PagoService } from '../../../services/pago.service';
import { UserService } from '../../../services/user.service';
import { Methods } from "../../../shared/methods";
import { Cell, DinamicData } from "src/app/models/dinamic-data";
import { ConfigService } from '../../../services/config.service';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ChatLogService } from "../../../services/chatlog.service";
import { forkJoin } from 'rxjs';
import { from } from 'rxjs';
import { concatMap, finalize, toArray } from 'rxjs/operators';

interface Option { value: string; name: string; }

@Component({
  selector: 'app-paymentrequest',
  templateUrl: './paymentrequest.component.html',
  styleUrls: ['./paymentrequest.component.css'],
  providers: [UserService, PagoService,ChatLogService]
})
export class PaymentrequestComponent implements OnInit , AfterViewInit {
  @ViewChild('stepper') stepper: MatStepper;
  private lastRows: Array<{
    id: number,
    po: { po: string },
    originalTotalCostPo: number,
    
  }> = [];
  private allRows: { [id: number]: {
    id: number,
    po: { po: string },
    originalTotalCostPo: number
  } } = {};
  get bulkPoList(): string {
    return this.bulkDetails
      .map(b => b.po)
      .join(', ');
  }
  get bulkTotal(): string {
    const total = this.bulkDetails
      .reduce((sum, b) => sum + (b.amount ?? 0), 0);
   
    return total.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
  }
  trackById(_index: number, item: { id: number }) {
    return item.id;
  }
  poOptions: Option[] = [
    { value: 'PO',          name: 'Purchase Order' },
    { value: 'Consignment', name: 'Consignment' }
  ];
  companyOptions: Option[] = [];       

  dataSource: Array<{ po: string; amount: number }> = [];
  displayedColumns = ['po', 'amount'];

  selectedPaymentType: string | null = null;
  selectedCompany:    string | null = null;
  public today: Date;
  public sinceDate: any = null;
  public toDate;
  filesCount = 0;
  public notesType = 'PAYMENT';
  public fatherid;
  submitting = false;
  saving = false;  
  step1Control: FormGroup;
  step2Control: FormGroup;
  step3Control: FormGroup;
  step4Control: FormGroup;
  step5Control: FormGroup;
  token: string;
  shippingOptions: Option[] = [
    { value: 'USPS',   name: 'USPS (no tracking)' },
    { value: 'UPS Ground',  name: 'UPS Ground' },
    { value: 'UPS Next Day Air Saver', name: 'UPS Next Day Air Saver' },
    { value: 'UPS Next Day Air',  name: 'UPS Next Day Air' },
    { value: 'UPS Next Day Early', name: 'UPS Next Day Early' },
  ];
  public paymentID;
  public showAmountError = false;
  /* variables para la tabla  */
  public mtds: Methods = new Methods();
  public options: Array<any> = [];
  public loading = false;
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public config: Array<any> = [];
  public podata: DinamicData = new DinamicData(
    ['check','PO', 'Vendor', 'Rep', 'Amount', 'Purchasing Terms','Manifest Status','Testing Status','Purchase Date']
  )
  modeACH: 'manual' | 'file' = 'manual';
   WTINTER: 'manual' | 'file' = 'manual';
  WTDOME: 'manual' | 'file' = 'manual';
  public selectedTabIndex = 0;
  public bulk: string[] = [];
  /*  */
  selectedMethodType: string = '';
  constructor(
    private fb: FormBuilder, private dialogRef: MatDialogRef<PaymentrequestComponent>,
    private _pagoService: PagoService,
    private _userService: UserService, private _config: ConfigService,  private _chatLogService: ChatLogService,
  ) {
    this.token = this._userService.getToken();
    this.today = new Date();
    this.today.setDate(this.today.getDate() + 1);
    this.toDate = this.getFecha(this.today);
    this.today.setDate(this.today.getDate() - 31);
    this.sinceDate = this.getFecha(this.today);

    this.sinceDate = new Date(this.sinceDate);
    this.toDate = new Date(this.toDate);
  }
  onFilesTotalChanged(count: number) {
    this.filesCount = count;

   
  }
  ngOnInit() {
  
    this.step1Control = this.fb.group({
      paymentType: [null, Validators.required],
      company:     [null, Validators.required],
    });




    this.step2Control = this.fb.group({
      received: [null, Validators.required],
      comment:  ['', Validators.minLength(2)]      
    });
    this.step2Control.get('received').valueChanges.subscribe(val => {
      const c = this.step2Control.get('comment');
      if (val === 'no') {
        c.setValidators([Validators.required, Validators.minLength(2)]);
      } else {
        c.clearValidators();
      }
      c.updateValueAndValidity();
    });
    /*  */
    this.step3Control = this.fb.group({
      tested:      [null, Validators.required],
      testComment: ['', Validators.minLength(2)]
    });

    
    this.step3Control.get('tested').valueChanges.subscribe(val => {
      const comment = this.step3Control.get('testComment');
      if (val === 'no') {
        comment.setValidators([Validators.required, Validators.minLength(2)]);
      } else {
        comment.clearValidators();
      }
      comment.updateValueAndValidity();
    });
  
    /* PaymentForm */
    this.step4Control = this.fb.group({
      // comunes
      invoiceNumber: [''],
      numberOfChecks: [1, [Validators.required, Validators.min(1), Validators.max(5)]],
      checks: this.fb.array([]),
      shippingAddress: [''],
      shippingMethod:  [null],
      paymentUrgency: [null, Validators.required],
      specificDate:   [null],
      paymentAmount: [null, [Validators.required, Validators.min(0.01)]],
      pickupDate:     [null],
    
      // ACH – Domestic
      Benefiname:     [''],
      routingname:    [''],
      accountnumber:  [''],
    
      // Wire – International
      Benefiaddr:     [''],
      accountNwt:     [''],
      swiftbankcode:  [''],
    
      // Wire – Domestic
      Benefinamewtdome:  [''],
      Benefiaddrwtdome:  [''],
      accountNwtdo:      [''],
      routingnumberwtdo: [''],
    
      // PayPal
      emailpaypal:    ['', Validators.email],
    
      // Credit Card
      ARdepartament:  [''],
      phonecredit:    [''],
      deparmentAR:    ['']
    }, {
      validators: [ this.checksSumValidator.bind(this) ]
    });
    this.step4Control.get('paymentAmount')!
    .valueChanges
    .subscribe(() => this.step4Control.updateValueAndValidity());

  this.step4Control.get('checks')!
    .valueChanges
    .subscribe(() => this.step4Control.updateValueAndValidity());

    this.step5Control = this.fb.group({
 
      test: [''],
    });
    this.updateChecksArray(1);

    this.step4Control.get('numberOfChecks')
    .valueChanges
    .subscribe(count => {
      this.updateChecksArray(count)
      this.updateMethodValidators();

    });

    this.step4Control.get('paymentUrgency')!
    .valueChanges
    .subscribe(val => {
      const ctrl = this.step4Control.get('specificDate')!;
      if (val === 'SpecificDate') {
        ctrl.setValidators([ Validators.required ]);
      } else {
        ctrl.clearValidators();
      }
      ctrl.updateValueAndValidity();
    });

    /*  End PaymentForm  */
    this.getlistvendor();
    this._config.getConfig('popayment').subscribe(
      r => {
        if (r.data) {
          this.options = JSON.parse(r.data.data);
          this.itemsPorPagina = r.data.pageLimit;
        } else {
          this.options = this.mtds.colopt(this.podata.headers, []);
        }
   
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
    this.selectedMethodType = this.methodCodes[0]; // o el índice que uses por default
    this.updateChecksArray(1); // asegúrate de tener 1 check por default
    this.updateMethodValidators();
    setTimeout(() => this.step4Control.updateValueAndValidity(), 0);
  }
  get numericBulkTotal(): number {
    return this.bulkDetails.reduce((sum, b) => sum + b.amount, 0);
  }
/*   private checksSumValidator(group: FormGroup) {
    const method = this.selectedMethodType;
    if (method !== 'CHECK_PICKUP' && method !== 'CHECK_MAILED') {
      return null;
    }
  
    const payment = Number(group.get('paymentAmount')!.value) || 0;
    const checks  = group.get('checks')!.value as Array<{amount: number}>;
    const sum     = checks
      .map(c => Number(c.amount) || 0)
      .reduce((acc, val) => acc + val, 0);
  
    return sum < payment 
      ? { sumTooLow: { required: payment, actual: sum } } 
      : null;
  } */
  private checksSumValidator(group: FormGroup) {
    const method = this.selectedMethodType;
  
    if (method !== 'CHECK_PICKUP' && method !== 'CHECK_MAILED') {
      return null;
    }
  
    const payment = Number(group.get('paymentAmount')!.value) || 0;
    const checks  = group.get('checks')!.value as Array<{amount: number}>;
    const sum     = checks
      .map(c => Number(c.amount) || 0)
      .reduce((acc, val) => acc + val, 0);

      if (checks.length < 1 || checks.length > 5) {
        return { invalidChecksCount: true };
      }
    if (sum !== payment) {
      return { sumNotEqual: { required: payment, actual: sum } };
    }

    return null;
  }
  
  setPercent(pct: number) {
    const val = this.numericBulkTotal * pct;
    this.step4Control
        .get('paymentAmount')
        .setValue(val.toFixed(2));
  }
  getlistvendor() {
    this._pagoService.getlistcompanies(this.token)
      .subscribe((response: any) => {
       
        this.companyOptions = response.companies.map(c => ({
          value: c.name,
          name:  c.name
        }));
      }, err => {
        console.error('Error cargando empresas', err);
      });
  }
  /* FILTROS */
  cleanfilter(){
    this.filtros = [
      null,
      {
        key: "po",
        title: "PO",
        value: "",
        type: "contains",
        key_type: "po_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "vendor",
        title: "Vendor",
        value: "",
        type: "contains",
        key_type: "vendor_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "rep",
        title: "Rep",
        value: "",
        type: "contains",
        key_type: "rep_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "amount",
        title: "Amount",
        value: "",
        type: "equalto",
        key_type: "amount_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "equalto", name: "Equal To" },
          { value: "notequalto", name: "Not Equal To" },
          { value: "greaterthan", name: "Greater Than" },
          { value: "lessthan", name: "Less Than" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "purchasing",
        title: "Purchasig Terms",
        value: "",
        type: "contains",
        key_type: "purchasing_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "manifest",
        title: "Manifest Status",
        value: "",
        type: "contains",
        key_type: "manifest_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "testing",
        title: "Testing Status",
        value: "",
        type: "contains",
        key_type: "testing_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "date",
        title: "Purchase Date",
        value: "",
        type: "equalto",
        key_type: "date_type",
        type_options:[
          { value: "nofilter", name: "No Filter" },
          { value: "equalto", name: "Equal To" },
          { value: "notequalto", name: "Not Equal To" },
          { value: "greaterthan", name: "Greater Than" },
          { value: "lessthan", name: "Less Than" },
        ],
      },
    ];
  }
  public filtros = [
        null,
        {
          key: "po",
          title: "PO",
          value: "",
          type: "contains",
          key_type: "po_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "vendor",
          title: "Vendor",
          value: "",
          type: "contains",
          key_type: "vendor_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "rep",
          title: "Rep",
          value: "",
          type: "contains",
          key_type: "rep_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "amount",
          title: "Amount",
          value: "",
          type: "equalto",
          key_type: "amount_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "equalto", name: "Equal To" },
            { value: "notequalto", name: "Not Equal To" },
            { value: "greaterthan", name: "Greater Than" },
            { value: "lessthan", name: "Less Than" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "purchasing",
          title: "Purchasig Terms",
          value: "",
          type: "contains",
          key_type: "purchasing_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "manifest",
          title: "Manifest Status",
          value: "",
          type: "contains",
          key_type: "manifest_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "testing",
          title: "Testing Status",
          value: "",
          type: "contains",
          key_type: "testing_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "date",
          title: "Purchase Date",
          value: "",
          type: "equalto",
          key_type: "date_type",
          type_options:[
            { value: "nofilter", name: "No Filter" },
            { value: "equalto", name: "Equal To" },
            { value: "notequalto", name: "Not Equal To" },
            { value: "greaterthan", name: "Greater Than" },
            { value: "lessthan", name: "Less Than" },
          ],
        },
      ];
  /* END FILTROS */
  getlistpo( e=null ){
    this.loading = true;
    let data={name:this.selectedCompany,sort:[this.filterrigh], order:this.sortStates}
    this._pagoService.getlistpobycompanies(this.token,data,e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,this.filtros)
    .subscribe((response: any) => {
      if (response.status === 'success') { 
        this.paginaActual = Number(response.page_actual);
        this.itemsPorPagina = String(response.items_per_page);
        this.totalItems = Number(response.total_items_count);
        this.totalPaginas = Number(response.total_pages);
        this.podata.rows = [];
        this.lastRows = response.data;
        for (let row of response.data) {
          this.allRows[row.id] = row;
        }
        for (let element of response.data) {
          const selected_value = this.bulk.includes(element.id.toString());
          const createAt = this.mtds.getFecha(
            new Date(element.po?.createdAt),
            "MM-dd-yyyy"
          );
          this.podata.rows.push(
            [ 
              new Cell(element.id , {
                type: "checkbox",
                selected: selected_value
               
              }),
              new Cell(element.po?.po ?? '' ),
              new Cell(element.clientName ?? ''),
              new Cell(element.po.rep ? `${element.po?.rep?.name ?? ''} ${element.po?.rep?.surname ?? ''}`.trim() : ''), 
              new Cell(element.originalTotalCostPo ?? ''),
              new Cell(element.po?.terms ?? ''),
              new Cell(element.manifestStatus ?? ''),
              new Cell(element.testingStatus ?? ''),
              new Cell(createAt),
            ]
          );
        }
        this.loading = false;
      }
    }, err => {
      console.error('Error cargando empresas', err);
      this.loading = false;
    });
  }
  /*  */
  // justo después de tus propiedades:
  methodCodes = [
    'CHECK_PICKUP',
    'CHECK_MAILED',
    'ACH_DOMESTIC',
    'WT_INTERNATIONAL',
    'WT_DOMESTIC',
    'PAYPAL',
    'CREDIT_CARD'
  ];

  onMethodTabChange(index: number) {
    this.selectedMethodType = this.methodCodes[index];
    this.updateMethodValidators();
    setTimeout(() => {
      this.step4Control.updateValueAndValidity();
    }, 0);
  }
/* SUBMIT DATA  */
submit() {
  /* if (this.submitting) return; */

  const paymentType        = this.step1Control.value.paymentType;
  const vendorId           =  1; 
  /* this.submitting = true; */
  let equipmentReceived ;
  let equipmentTested;
  if (this.selectedPaymentType === 'PO') { 
  equipmentReceived = this.step2Control.value?.received?.toUpperCase(); 
  equipmentTested = this.step3Control.value?.tested?.toUpperCase() ?? 'NO'; 
}
  const paymentDueType     = this.step4Control.value?.paymentUrgency; 
  
  const paymentDueDate = this.step4Control.value.specificDate
  ? this.formatDate(this.step4Control.value.specificDate)
  : null; 

  const status             = 'Draft';
  const wizardStep         = this.stepper.selectedIndex + 1; 
 
  let totalAmount        = this.numericBulkTotal;              
  let requestedAmount    = this.step4Control.value?.paymentAmount; 
  if (this.selectedPaymentType === 'Consignment') {
    totalAmount = requestedAmount;
   }

  const items = this.bulk.map(idStr => ({
    poInfoId:               null,
    processingInstructionId: +idStr,
    originalTotalCostPo:    null,
    requestedAmount: this.step4Control.value.paymentAmount
  }));
  
  const md: any = {
    methodType:    this.selectedMethodType,         
    invoiceNumber: this.step4Control.value.invoiceNumber,
    numberOfChecks:this.step4Control.value.numberOfChecks
  };
  
/*   if (this.selectedMethodType.startsWith('CHECK')) {
    
    this.checks.controls.forEach((grp, i) => {
      md[`checkPayableTo${i+1}`] = grp.value.payableTo;
      md[`checkAmount${i+1}`]    = grp.value.amount.toFixed(2);
    });
    if (this.selectedMethodType === 'CHECK_PICKUP') {
      md.pickupDatetime = this.formatDateTime(this.step4Control.value.pickupDate);
    } else {
      md.shippingAddress = this.step4Control.value.shippingAddress;
      md.shippingMethod  = this.step4Control.value.shippingMethod;
    }
  } */
  switch (this.selectedMethodType) {
    case 'CHECK_PICKUP':
    case 'CHECK_MAILED':
     
      this.checks.controls.forEach((grp, i) => {
        md[`checkPayableTo${i+1}`] = grp.value?.payableTo;
        md[`checkAmount${i+1}`]    = grp.value?.amount?.toFixed(2);
      });
      if (this.selectedMethodType === 'CHECK_PICKUP') {
        md.pickupDatetime = this.formatDateTime(this.step4Control.value?.pickupDate);
      } else {
        md.shippingAddress = this.step4Control.value.shippingAddress;
        md.shippingMethod  = this.step4Control.value.shippingMethod;
      }
      break;

    case 'ACH_DOMESTIC':
      md.achBeneficiaryName  = this.step4Control.value.Benefiname;
      md.achRoutingNumber    = this.step4Control.value.routingname;
      md.achAccountNumber    = this.step4Control.value.accountnumber;
      break;

    case 'WT_INTERNATIONAL':
      md.wtBeneficiaryName      = this.step4Control.value.Benefiname;
      md.wtBeneficiaryAddress   = this.step4Control.value.Benefiaddr;
      md.wtClabe                = this.step4Control.value.accountNwt;
      md.wtSwiftCode            = this.step4Control.value.swiftbankcode;
      break;

    case 'WT_DOMESTIC':
      md.wtBeneficiaryName      = this.step4Control.value.Benefinamewtdome;
      md.wtDomesticBeneficiaryAddress = this.step4Control.value.Benefiaddrwtdome;
      md.wtDomesticAccountNumber      = this.step4Control.value.accountNwtdo;
      md.wtDomesticRoutingNumber      = this.step4Control.value.routingnumberwtdo;
      break;

    case 'PAYPAL':
      md.paypalEmail = this.step4Control.value.emailpaypal;
      break;

    case 'CREDIT_CARD':
      md.ccContactName  = this.step4Control.value.ARdepartament;
      md.ccPhoneNumber  = this.step4Control.value.phonecredit;
      md.ccContactEmail = this.step4Control.value.deparmentAR;
      break;
  }
  const note5 = this.step5Control.value?.test?.trim();
  let notes5 = `Additional Notes – ${note5}`;

  const payload : any = {
    vendorId,
    paymentType,
    equipmentReceived,
    equipmentTested,
    note5,
    paymentDueType,
    paymentDueDate,
    status,
    wizardStep,
    totalAmount,
    requestedAmount,
    items,
    methodDetail: md
  };
  if (this.selectedPaymentType === 'Consignment') {
    payload.consignmentDetail = {
      dateFrom: this.formatDate(this.sinceDate),  
      dateTo:   this.formatDate(this.toDate),    
      fileGroupId: null,
      ClientName: this.selectedCompany
    };
  }

  this._pagoService.createpayentpartial(this.token, payload)
  .subscribe((response: any) => {
    if (response.status !== 'success') return;

    this.paymentID = response.payment_id;
  /*   const fatherId  = `payment-${paymentId}`;

    let received;
    let tested;
    let msg2;
    let msg3;
    if (this.selectedPaymentType === 'PO') { 
    received = this.step2Control.value?.received?.toUpperCase();
    tested= this.step3Control.value?.tested?.toUpperCase();
    msg2 = `Has the equipment been received? – ${received}`;
     msg3 = `Has the equipment been tested and quantities confirmed? – ${tested}`;
    if (received === 'NO') {
      msg2 += ` – ${this.step2Control.value.comment}`;
    }

    
 
    if (tested === 'NO') {
      msg3 += ` – ${this.step3Control.value.testComment}`;
    }
  }
   

    const calls = [];

    if (this.selectedPaymentType === 'PO') {
      calls.push(
        this._chatLogService.createchatforpayment(this.token, {
          father_id:   fatherId,
          message:     msg2,
          type:        'PAYMENT',
          paymentid:   paymentId,
          stepPayment: 2
        }),
        this._chatLogService.createchatforpayment(this.token, {
          father_id:   fatherId,
          message:     msg3,
          type:        'PAYMENT',
          paymentid:   paymentId,
          stepPayment: 3
        })
      );
    }
    
    if (note5) {
      calls.push(
        this._chatLogService.createchatforpayment(this.token, {
          father_id:   fatherId,
          message:     notes5,
          type:        'PAYMENT',
          paymentid:   paymentId,
          stepPayment: 5
        })
      );
    } */

    
    /* from(calls).pipe(
      concatMap(call$ => call$),  
      toArray()                     
    ).subscribe(() => {
      this.submitting = false
      this.showToast('success', 'Payment has been created', 2000);
      this.close();
    }); */
  });
}

/* SAVE */
/* saveforcosigment(){
  const paymentType        = this.step1Control.value.paymentType;
  const vendorId           =  1; 
  const status             = 'Draft';
  const wizardStep         = this.stepper.selectedIndex + 1; 
  const md: any = {
    methodType:    this.selectedMethodType,         
    invoiceNumber: this.step4Control.value.invoiceNumber,
    numberOfChecks:this.step4Control.value.numberOfChecks
  };
  switch (this.selectedMethodType) {
    case 'CHECK_PICKUP':
    case 'CHECK_MAILED':
     
      this.checks.controls.forEach((grp, i) => {
        md[`checkPayableTo${i+1}`] = grp.value?.payableTo;
        md[`checkAmount${i+1}`]    = grp.value?.amount?.toFixed(2);
      });
      if (this.selectedMethodType === 'CHECK_PICKUP') {
        md.pickupDatetime = this.safeFormatDate(this.step4Control?.value.pickupDate);
      } else {
        md.shippingAddress = this.step4Control.value.shippingAddress;
        md.shippingMethod  = this.step4Control.value.shippingMethod;
      }
      break;

    case 'ACH_DOMESTIC':
      md.achBeneficiaryName  = this.step4Control.value.Benefiname;
      md.achRoutingNumber    = this.step4Control.value.routingname;
      md.achAccountNumber    = this.step4Control.value.accountnumber;
      break;

    case 'WT_INTERNATIONAL':
      md.wtBeneficiaryName      = this.step4Control.value.Benefiname;
      md.wtBeneficiaryAddress   = this.step4Control.value.Benefiaddr;
      md.wtClabe                = this.step4Control.value.accountNwt;
      md.wtSwiftCode            = this.step4Control.value.swiftbankcode;
      break;

    case 'WT_DOMESTIC':
      md.wtBeneficiaryName      = this.step4Control.value.Benefinamewtdome;
      md.wtDomesticBeneficiaryAddress = this.step4Control.value.Benefiaddrwtdome;
      md.wtDomesticAccountNumber      = this.step4Control.value.accountNwtdo;
      md.wtDomesticRoutingNumber      = this.step4Control.value.routingnumberwtdo;
      break;

    case 'PAYPAL':
      md.paypalEmail = this.step4Control.value.emailpaypal;
      break;

    case 'CREDIT_CARD':
      md.ccContactName  = this.step4Control.value.ARdepartament;
      md.ccPhoneNumber  = this.step4Control.value.phonecredit;
      md.ccContactEmail = this.step4Control.value.deparmentAR;
      break;
  }

  const payload : any = {
    vendorId,
    paymentType,
    undefined,

    status,
    wizardStep,
    methodDetail: md
  };
  if (this.selectedPaymentType === 'Consignment') {
    payload.consignmentDetail = {
      dateFrom: this.safeFormatDate(this.sinceDate),  
      dateTo:   this.safeFormatDate(this.toDate),    
      fileGroupId: null,
      ClientName: this.selectedCompany
    };
  }
  console.log('→ payload:', payload);
  this._pagoService.Createnewpayment(this.token, payload)
  .subscribe((response: any) => {
    if (response.status !== 'success') return;

    this.paymentID = response.payment_id;

  })
} */

Savedcosigmentbyid(){
  if (this.saving) return;
  this.saving = true;
  const paymentId = this.paymentID; 
  let equipmentReceived ;
  let equipmentTested;
  if (this.selectedPaymentType === 'PO') { 
  equipmentReceived = this.step2Control.value?.received?.toUpperCase(); 
  equipmentTested = this.step3Control.value?.tested?.toUpperCase(); 
}
  const paymentDueType     = this.step4Control.value.paymentUrgency; 
  
  const paymentDueDate = this.step4Control.value.specificDate
  ? this.formatDate(this.step4Control.value?.specificDate)
  : null; 
  const paymentType        = this.step1Control.value.paymentType;
  const wizardStep         = this.stepper.selectedIndex + 1; 
 
  let totalAmount        = this.numericBulkTotal;              
  let requestedAmount    = this.step4Control.value.paymentAmount; 
  if (this.selectedPaymentType === 'Consignment') {
    totalAmount = requestedAmount;
   }

const getModeForm = (methodType: string) => {
  switch (methodType) {
    case 'ACH_DOMESTIC':      return this.modeACH === 'manual' ? 1 : 0;
    case 'WT_INTERNATIONAL':  return this.WTINTER === 'manual' ? 1 : 0;
    case 'WT_DOMESTIC':       return this.WTDOME === 'manual' ? 1 : 0;
    default: return null;
  }
};

  const items = this.bulk.map(idStr => ({
    poInfoId:               null,
    processingInstructionId: +idStr,
    originalTotalCostPo:    null,
    requestedAmount: this.step4Control.value.paymentAmount
  }));
  
  const md: any = {
    methodType:    this.selectedMethodType,         
    invoiceNumber: this.step4Control.value.invoiceNumber,
    numberOfChecks:this.step4Control.value.numberOfChecks
  };
  
  md.modeform = getModeForm(this.selectedMethodType);



  switch (this.selectedMethodType) {
    case 'CHECK_PICKUP':
    case 'CHECK_MAILED':
     
      this.checks.controls.forEach((grp, i) => {
        md[`checkPayableTo${i+1}`] = grp.value.payableTo;
        md[`checkAmount${i+1}`]    = grp.value?.amount?.toFixed(2);
      });
      if (this.selectedMethodType === 'CHECK_PICKUP') {
        md.pickupDatetime = this.formatDateTime(this.step4Control.value?.pickupDate);
      } else {
        md.shippingAddress = this.step4Control.value.shippingAddress;
        md.shippingMethod  = this.step4Control.value.shippingMethod;
      }
      break;

    case 'ACH_DOMESTIC':
      md.achBeneficiaryName  = this.step4Control.value.Benefiname;
      md.achRoutingNumber    = this.step4Control.value.routingname;
      md.achAccountNumber    = this.step4Control.value.accountnumber;
      break;

    case 'WT_INTERNATIONAL':
      md.wtBeneficiaryName      = this.step4Control.value.Benefiname;
      md.wtBeneficiaryAddress   = this.step4Control.value.Benefiaddr;
      md.wtClabe                = this.step4Control.value.accountNwt;
      md.wtSwiftCode            = this.step4Control.value.swiftbankcode;
      break;

    case 'WT_DOMESTIC':
      md.wtBeneficiaryName      = this.step4Control.value.Benefinamewtdome;
      md.wtDomesticBeneficiaryAddress = this.step4Control.value.Benefiaddrwtdome;
      md.wtDomesticAccountNumber      = this.step4Control.value.accountNwtdo;
      md.wtDomesticRoutingNumber      = this.step4Control.value.routingnumberwtdo;
      break;

    case 'PAYPAL':
      md.paypalEmail = this.step4Control.value.emailpaypal;
      break;

    case 'CREDIT_CARD':
      md.ccContactName  = this.step4Control.value.ARdepartament;
      md.ccPhoneNumber  = this.step4Control.value.phonecredit;
      md.ccContactEmail = this.step4Control.value.deparmentAR;
      break;
  }
  const note5 = this.step5Control.value.test?.trim();
  let notes5 = `Additional Notes – ${note5}`;
  
  const payload: any = {
    id: paymentId,  
    paymentType,
    equipmentReceived,
    equipmentTested,
    note5,
    paymentDueType,
    paymentDueDate,
    status,
    wizardStep,
    totalAmount,
    requestedAmount,
    items,
    methodDetail: md
  };
 
  if (this.selectedPaymentType === 'Consignment') {
    payload.consignmentDetail = {
      dateFrom: this.formatDate(this.sinceDate),  
      dateTo:   this.formatDate(this.toDate),    
      fileGroupId: null,
      ClientName: this.selectedCompany
    };
  }
 
  payload.status = "Draft";
  
  this._pagoService.savepartial(this.token, payload)
    .subscribe((response: any) => {
      this.submitting = false;
      if (response.status !== 'success') return;
      const fatherId  = `payment-${this.paymentID}`;

      
  
      const calls = [];
      if (this.selectedPaymentType === 'PO') {
        const rCtrl = this.step2Control.get('received');
        if (rCtrl.value != null) {
          let msg2 = `Has the equipment been received? – ${rCtrl.value.toUpperCase()}`;
          if (rCtrl.value.toUpperCase() === 'NO') {
            const c = this.step2Control.get('comment').value;
            if (c) msg2 += ` – ${c}`;
          }
          calls.push(
            this._chatLogService.createchatforpayment(this.token, {
              father_id:   fatherId,
              message:     msg2,
              type:        'PAYMENT',
              paymentid:   paymentId,
              stepPayment: 2
            })
          );
        }
      
        const tCtrl = this.step3Control.get('tested');
        if (tCtrl.value != null) {
          let msg3 = `Has the equipment been tested and quantities confirmed? – ${tCtrl.value.toUpperCase()}`;
          if (tCtrl.value.toUpperCase() === 'NO') {
            const tc = this.step3Control.get('testComment').value;
            if (tc) msg3 += ` – ${tc}`;
          }
          calls.push(
            this._chatLogService.createchatforpayment(this.token, {
              father_id:   fatherId,
              message:     msg3,
              type:        'PAYMENT',
              paymentid:   paymentId,
              stepPayment: 3
            })
          );
        }
      }
     
      const note5 = this.step5Control.value.test?.trim();
      let notes5 = `Additional Notes – ${note5}`;
      
  
  /*     if (this.selectedPaymentType === 'PO') {
        calls.push(
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     msg2,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 2
          }),
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     msg3,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 3
          })
        );
      } */
      
      if (note5) {
        calls.push(
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     notes5,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 5
          })
        );
      }
      from(calls).pipe(
        concatMap(call$ => call$),  
        toArray()                     
      ).subscribe(() => {
        this.saving = false
        this.showToast('success', 'Payment has been Saved', 2000);
        this.close();
      });
    }, err => {
      this.saving = false
      this.showToast('error', 'Error Creating a Payment', 2000);
    });
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
submitforanypayment() {
  if (this.submitting) return;
  this.submitting = true;

  const paymentType        = this.step1Control.value.paymentType;
  const vendorId           =  1; 
  
  let equipmentReceived ;
  let equipmentTested;
  if (this.selectedPaymentType === 'PO') { 
  equipmentReceived = this.step2Control.value.received.toUpperCase(); 
  equipmentTested = this.step3Control.value.tested?.toUpperCase() ?? 'NO'; 
}
  const paymentDueType     = this.step4Control.value.paymentUrgency; 
  
  const paymentDueDate = this.step4Control.value.specificDate
  ? this.formatDate(this.step4Control.value.specificDate)
  : null; 

  const status             = 'Pending Approval';
  const wizardStep         = this.stepper.selectedIndex + 1; 
 // modeform: 1 = manual, 0 = archivo
const getModeForm = (methodType: string) => {
  switch (methodType) {
    case 'ACH_DOMESTIC':      return this.modeACH === 'manual' ? 1 : 0;
    case 'WT_INTERNATIONAL':  return this.WTINTER === 'manual' ? 1 : 0;
    case 'WT_DOMESTIC':       return this.WTDOME === 'manual' ? 1 : 0;
    default: return null;
  }
};

  let totalAmount        = this.numericBulkTotal;              
  let requestedAmount    = this.step4Control.value.paymentAmount; 
  if (this.selectedPaymentType === 'Consignment') {
    totalAmount = requestedAmount;
   }

  const items = this.bulk.map(idStr => ({
    poInfoId:               null,
    processingInstructionId: +idStr,
    originalTotalCostPo:    null,
    requestedAmount: this.step4Control.value.paymentAmount
  }));
  
  const md: any = {
    methodType:    this.selectedMethodType,         
    invoiceNumber: this.step4Control.value.invoiceNumber,
    numberOfChecks:this.step4Control.value.numberOfChecks
  };
  md.modeform = getModeForm(this.selectedMethodType);
  const paymentId = this.paymentID; 




  switch (this.selectedMethodType) {
    case 'CHECK_PICKUP':
    case 'CHECK_MAILED':
     
      this.checks.controls.forEach((grp, i) => {
        md[`checkPayableTo${i+1}`] = grp.value.payableTo;
        md[`checkAmount${i+1}`]    = grp.value.amount.toFixed(2);
      });
      if (this.selectedMethodType === 'CHECK_PICKUP') {
        md.pickupDatetime = this.formatDateTime(this.step4Control.value.pickupDate);
      } else {
        md.shippingAddress = this.step4Control.value.shippingAddress;
        md.shippingMethod  = this.step4Control.value.shippingMethod;
      }
      break;

    case 'ACH_DOMESTIC':
      md.achBeneficiaryName  = this.step4Control.value.Benefiname;
      md.achRoutingNumber    = this.step4Control.value.routingname;
      md.achAccountNumber    = this.step4Control.value.accountnumber;
      break;

    case 'WT_INTERNATIONAL':
      md.wtBeneficiaryName      = this.step4Control.value.Benefiname;
      md.wtBeneficiaryAddress   = this.step4Control.value.Benefiaddr;
      md.wtClabe                = this.step4Control.value.accountNwt;
      md.wtSwiftCode            = this.step4Control.value.swiftbankcode;
      break;

    case 'WT_DOMESTIC':
      md.wtBeneficiaryName            = this.step4Control.value.Benefinamewtdome;
      md.wtDomesticBeneficiaryAddress = this.step4Control.value.Benefiaddrwtdome;
      md.wtDomesticAccountNumber      = this.step4Control.value.accountNwtdo;
      md.wtDomesticRoutingNumber      = this.step4Control.value.routingnumberwtdo;
      break;

    case 'PAYPAL':
      md.paypalEmail = this.step4Control.value.emailpaypal;
      break;

    case 'CREDIT_CARD':
      md.ccContactName  = this.step4Control.value.ARdepartament;
      md.ccPhoneNumber  = this.step4Control.value.phonecredit;
      md.ccContactEmail = this.step4Control.value.deparmentAR;
      break;
  }
  const note5 = this.step5Control.value.test?.trim();
  let notes5 = `Additional Notes – ${note5}`;
  
  const payload: any = {
    id: paymentId,  
    paymentType,
    equipmentReceived,
    equipmentTested,
    note5,
    paymentDueType,
    paymentDueDate,
    status,
    wizardStep,
    totalAmount,
    requestedAmount,
    items,
    methodDetail: md
  };
  payload.status = "Pending Approval";
  if (this.selectedPaymentType === 'Consignment') {
    payload.consignmentDetail = {
      dateFrom: this.formatDate(this.sinceDate),  
      dateTo:   this.formatDate(this.toDate),    
      fileGroupId: null,
      ClientName: this.selectedCompany
    };
  }
  this._pagoService.completedata(this.token, payload)
    .subscribe((response: any) => {
      this.submitting = false;
      if (response.status !== 'success') return;
      const fatherId  = `payment-${paymentId}`;

      let received;
      let tested;
      let msg2;
      let msg3;
      if (this.selectedPaymentType === 'PO') { 
      received = this.step2Control.value.received.toUpperCase();
      tested= this.step3Control.value.tested.toUpperCase();
      msg2 = `Has the equipment been received? – ${received}`;
       msg3 = `Has the equipment been tested and quantities confirmed? – ${tested}`;
      if (received === 'NO') {
        msg2 += ` – ${this.step2Control.value.comment}`;
      }
  
      
   
      if (tested === 'NO') {
        msg3 += ` – ${this.step3Control.value.testComment}`;
      }
    }
     
  
      const calls = [];
  
      if (this.selectedPaymentType === 'PO') {
        calls.push(
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     msg2,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 2
          }),
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     msg3,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 3
          })
        );
      }
      
      if (note5) {
        calls.push(
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     notes5,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 5
          })
        );
      }
      from(calls).pipe(
        concatMap(call$ => call$),  
        toArray()                     
      ).subscribe(() => {
        this.showToast('success', 'Payment has been created', 2000);
        this.submitting = false
        this.close();
      });
    }, err => {
      this.showToast('error', 'Error Creating a Payment', 2000);
      this.submitting = false;
    });
}



/*  */
 /* save(){
 
 if (this.saving) return;
 this.saving = true;
 
 console.log('Controles cheque:', this.checks.length);   // ¿sale 5 cuando pusiste 5?
  console.log('Valores cheque:', this.step4Control.value.checks);
  console.log('selectedMethodType antes de payload:', this.selectedMethodType);
  const paymentType        = this.step1Control.value.paymentType;
  const vendorId           =  1; 
  let equipmentReceived ;
  let equipmentTested;
  if (this.selectedPaymentType === 'PO') { 
  equipmentReceived = this.step2Control?.value?.received?.toUpperCase(); 
  equipmentTested = this.step3Control.value.tested?.toUpperCase() ?? 'NO'; 
}
  const paymentDueType     = this.step4Control.value.paymentUrgency; 
  
  const paymentDueDate = this.step4Control.value.specificDate
  ? this.formatDate(this.step4Control.value.specificDate)
  : null; 

  const status             = 'Draft';
  const wizardStep         = this.stepper.selectedIndex + 1; 
 
  let totalAmount        = this.numericBulkTotal;              
  let requestedAmount    = this.step4Control.value.paymentAmount; 
  if (this.selectedPaymentType === 'Consignment') {
    totalAmount = requestedAmount;
   }

  const items = this.bulk.map(idStr => ({
    poInfoId:               null,
    processingInstructionId: +idStr,
    originalTotalCostPo:    null,
    requestedAmount: this.step4Control.value.paymentAmount
  }));
  
  const md: any = {
    methodType:    this.selectedMethodType,         
    invoiceNumber: this.step4Control.value.invoiceNumber,
    numberOfChecks:this.step4Control.value.numberOfChecks
  };
  
  if (this.selectedMethodType.startsWith('CHECK')) {
    
    this.checks.controls.forEach((grp, i) => {
      md[`checkPayableTo${i+1}`] = grp.value.payableTo;
      md[`checkAmount${i+1}`]    = grp.value.amount.toFixed(2);
    });
    if (this.selectedMethodType === 'CHECK_PICKUP') {
      md.pickupDatetime = this.formatDateTime(this.step4Control.value.pickupDate);
    } else {
      md.shippingAddress = this.step4Control.value.shippingAddress;
      md.shippingMethod  = this.step4Control.value.shippingMethod;
    }
  }
  switch (this.selectedMethodType) {
    case 'CHECK_PICKUP':
    case 'CHECK_MAILED':
     
      this.checks.controls.forEach((grp, i) => {
        md[`checkPayableTo${i+1}`] = grp.value?.payableTo;
        md[`checkAmount${i+1}`]    = grp.value?.amount?.toFixed(2);
      });
      if (this.selectedMethodType === 'CHECK_PICKUP') {
        md.pickupDatetime = this.safeFormatDate(this.step4Control?.value.pickupDate);
      } else {
        md.shippingAddress = this.step4Control.value.shippingAddress;
        md.shippingMethod  = this.step4Control.value.shippingMethod;
      }
      break;

    case 'ACH_DOMESTIC':
      md.achBeneficiaryName  = this.step4Control.value.Benefiname;
      md.achRoutingNumber    = this.step4Control.value.routingname;
      md.achAccountNumber    = this.step4Control.value.accountnumber;
      break;

    case 'WT_INTERNATIONAL':
      md.wtBeneficiaryName      = this.step4Control.value.Benefiname;
      md.wtBeneficiaryAddress   = this.step4Control.value.Benefiaddr;
      md.wtClabe                = this.step4Control.value.accountNwt;
      md.wtSwiftCode            = this.step4Control.value.swiftbankcode;
      break;

    case 'WT_DOMESTIC':
      md.wtDomesticBeneficiaryAddress = this.step4Control.value.Benefiaddrwtdome;
      md.wtDomesticAccountNumber      = this.step4Control.value.accountNwtdo;
      md.wtDomesticRoutingNumber      = this.step4Control.value.routingnumberwtdo;
      break;

    case 'PAYPAL':
      md.paypalEmail = this.step4Control.value.emailpaypal;
      break;

    case 'CREDIT_CARD':
      md.ccContactName  = this.step4Control.value.ARdepartament;
      md.ccPhoneNumber  = this.step4Control.value.phonecredit;
      md.ccContactEmail = this.step4Control.value.deparmentAR;
      break;
  }


  const payload : any = {
    vendorId,
    paymentType,
    equipmentReceived,
    equipmentTested,
    paymentDueType,
    paymentDueDate,
    status,
    wizardStep,
    totalAmount,
    requestedAmount,
    items,
    methodDetail: md
  };
  if (this.selectedPaymentType === 'Consignment') {
    payload.consignmentDetail = {
      dateFrom: this.safeFormatDate(this.sinceDate),  
      dateTo:   this.safeFormatDate(this.toDate),    
      fileGroupId: null,
      ClientName: this.selectedCompany
    };
  }
  console.log('→ payload:', payload);
  this._pagoService.Createnewpayment(this.token, payload)
  .subscribe((response: any) => {
    if (response.status !== 'success') return;

    const paymentId = response.payment_id;
    const fatherId  = `payment-${paymentId}`;

    let received;
    let tested;
    let msg2;
    let msg3;

    const calls = [];
    if (this.selectedPaymentType === 'PO') {
      const rCtrl = this.step2Control.get('received');
      if (rCtrl.value != null) {
        let msg2 = `Has the equipment been received? – ${rCtrl.value.toUpperCase()}`;
        if (rCtrl.value.toUpperCase() === 'NO') {
          const c = this.step2Control.get('comment').value;
          if (c) msg2 += ` – ${c}`;
        }
        calls.push(
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     msg2,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 2
          })
        );
      }
    
      const tCtrl = this.step3Control.get('tested');
      if (tCtrl.value != null) {
        let msg3 = `Has the equipment been tested and quantities confirmed? – ${tCtrl.value.toUpperCase()}`;
        if (tCtrl.value.toUpperCase() === 'NO') {
          const tc = this.step3Control.get('testComment').value;
          if (tc) msg3 += ` – ${tc}`;
        }
        calls.push(
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     msg3,
            type:        'PAYMENT',
            paymentid:   paymentId,
            stepPayment: 3
          })
        );
      }
    }
   
    const note5 = this.step5Control.value.test?.trim();
    let notes5 = `Additional Notes – ${note5}`;
    


    
    if (note5) {
      calls.push(
        this._chatLogService.createchatforpayment(this.token, {
          father_id:   fatherId,
          message:     notes5,
          type:        'PAYMENT',
          paymentid:   paymentId,
          stepPayment: 5
        })
      );
    }

    
    from(calls).pipe(
      concatMap(call$ => call$),  
      toArray()                     
    ).subscribe(() => {
      this.saving = false
      this.showToast('success', 'Payment has been Saved', 2000);
      this.close();
    });
  }); */
 /* END */
/*  } */
/* SAVE */
private formatDate(d: Date): string {
  const yyyy = d?.getFullYear();
  const mm   = String(d?.getMonth()+1).padStart(2,'0');
  const dd   = String(d?.getDate()   ).padStart(2,'0');
  return `${yyyy}-${mm}-${dd}`;
}
private formatDateTime(d: Date): string {
  const date = this.formatDate(d);
  const hh   = String(d?.getHours()  ).padStart(2,'0');
  const mi   = String(d?.getMinutes()).padStart(2,'0');
  const ss   = String(d?.getSeconds()).padStart(2,'0');
  return `${date} ${hh}:${mi}:${ss}`;
}
private calculateNextRunDate(): string {
  
  return this.formatDate(new Date()); // sólo de ejemplo
} 

/* END SUBMIT DATA */
  get bulkDetails(): Array<{ id: number; po: string; amount: number }> {
    return this.bulk
      .map(idStr => {
        const id = +idStr;
        const r  = this.allRows[id];
        return r
          ? { id: r.id, po: r.po.po, amount: Number(r.originalTotalCostPo) }
          : null;
      })
      .filter(x => x !== null) as any;
  }

  onSelectPaymentType(value: string):void {
    this.bulk = [];
    this.cleanfilter();
    this.selectedPaymentType = value;

    this.selectedCompany = null;
    this.dataSource      = [];
    this.step1Control.get('company').reset();
    if (value === 'Consignment') {
      this.sinceDate = null;
      this.toDate    = null;
    }
  }

  onSelectCompany(value: string) {
    this.bulk = [];
    this.cleanfilter();
    this.selectedCompany = value;
    
   /*  this.dataSource = [
      { po: '0001', amount: 1500 },
      { po: '0004', amount: 2000 },
      { po: '0008', amount: 1750 }
    ]; */
    this.getlistpo();
  }

  posend(){
    if(this.selectedPaymentType === 'Consignment'){

    }
   /*  this.saveforcosigment(); */
   this.submit();
  }
  /* REGION FORMULARIOS */
    /*Payment Form  */
    get checks(): FormArray {
      return this.step4Control.get('checks') as FormArray;
    }
    private createCheckGroup(): FormGroup {
      return this.fb.group({
        payableTo: ['', Validators.required],
        amount: [null, [Validators.required, Validators.min(0.01)]]
      });
    }
    private updateChecksArray(count: number) {
      
      while (this.checks.length < count) {
        this.checks.push(this.createCheckGroup());
      }
      while (this.checks.length > count) {
        this.checks.removeAt(this.checks.length - 1);
      }
    
    }
    incrementChecks() {
      const ctrl = this.step4Control.get('numberOfChecks');
      if (ctrl.value < 5) ctrl.setValue(ctrl.value + 1);
    }
    decrementChecks() {
      const ctrl = this.step4Control.get('numberOfChecks');
      if (ctrl.value > 1) ctrl.setValue(ctrl.value - 1);
    }
    /* PaymentForm */
    
  /* END REGION FORMULARIOS */
  close() {
    this.dialogRef.close();
  }


  private updateMethodValidators() {
    const c = this.step4Control;
  
    
    const isCheck = this.selectedMethodType.startsWith('CHECK');

    const checksArray = c.get('checks');
  
    const numChecks   = c.get('numberOfChecks');

    const pickupCtrl  = c.get('pickupDate');
    const shipAddr    = c.get('shippingAddress');
    const shipMethod  = c.get('shippingMethod');
  
    if (isCheck) {
      checksArray.enable({ emitEvent: false });
      numChecks.enable({ emitEvent: false });
      pickupCtrl.enable({ emitEvent: false });
      shipAddr.enable({ emitEvent: false });
      shipMethod.enable({ emitEvent: false });
    } else {
      checksArray.disable({ emitEvent: false });
      numChecks.disable({ emitEvent: false });
      pickupCtrl.disable({ emitEvent: false });
      shipAddr.disable({ emitEvent: false });
      shipMethod.disable({ emitEvent: false });
    }
  
    const dynamicFields = [
      'invoiceNumber',
      'numberOfChecks','checks','pickupDate',
      'shippingAddress','shippingMethod',
      'Benefiname','routingname','accountnumber',
      'Benefiaddr','accountNwt','swiftbankcode',
      'Benefinamewtdome','Benefiaddrwtdome','accountNwtdo','routingnumberwtdo',
      'emailpaypal','ARdepartament','phonecredit','deparmentAR'
    ];
    dynamicFields.forEach(name => {
      const ctrl = c.get(name);
     /*  if (!ctrl) return; */
      ctrl.clearValidators();
      ctrl.updateValueAndValidity({ emitEvent: false });
    });
  
    this.checks.controls.forEach(group => {
      group.get('payableTo').clearValidators();
      group.get('amount').clearValidators();
      group.get('payableTo').updateValueAndValidity({ emitEvent: false });
      group.get('amount').updateValueAndValidity({ emitEvent: false });
    });

    c.get('paymentAmount').setValidators([Validators.required, Validators.min(0.01)]);
    c.get('paymentUrgency').setValidators([Validators.required]);
  
    
    switch (this.selectedMethodType) {
      case 'CHECK_PICKUP':
       /*  c.get('invoiceNumber').setValidators([Validators.required]); */
        c.get('pickupDate').setValidators([Validators.required]);
        c.get('numberOfChecks').setValidators([Validators.required, Validators.min(1), Validators.max(5)]);
        
        this.checks.controls.forEach(group => {
          group.get('payableTo').setValidators([Validators.required]);
          group.get('amount').setValidators([Validators.required, Validators.min(0.01)]);
        });
        break;
  
      case 'CHECK_MAILED':
        c.get('numberOfChecks').setValidators([Validators.required, Validators.min(1), Validators.max(5)]);
        c.get('shippingAddress').setValidators([Validators.required]);
        c.get('shippingMethod').setValidators([Validators.required]);
        break;
  
      case 'ACH_DOMESTIC':
        if (this.modeACH === 'manual') {
          c.get('Benefiname').enable({ emitEvent: false });
          c.get('routingname').enable({ emitEvent: false });
          c.get('accountnumber').enable({ emitEvent: false });
      
          c.get('Benefiname').setValidators([Validators.required]);
          c.get('routingname').setValidators([Validators.required]);
          c.get('accountnumber').setValidators([Validators.required]);
        } else {
          c.get('Benefiname').disable({ emitEvent: false });
          c.get('routingname').disable({ emitEvent: false });
          c.get('accountnumber').disable({ emitEvent: false });
      
          c.get('Benefiname').clearValidators();
          c.get('routingname').clearValidators();
          c.get('accountnumber').clearValidators();
        }
        break;
  
        case 'WT_INTERNATIONAL':
          if (this.WTINTER === 'manual') {
            c.get('Benefiname').enable({ emitEvent: false });
            c.get('Benefiaddr').enable({ emitEvent: false });
            c.get('accountNwt').enable({ emitEvent: false });
            c.get('swiftbankcode').enable({ emitEvent: false });
        
            c.get('Benefiname').setValidators([Validators.required]);
            c.get('Benefiaddr').setValidators([Validators.required]);
            c.get('accountNwt').setValidators([Validators.required]);
            c.get('swiftbankcode').setValidators([Validators.required]);
          } else {
            c.get('Benefiname').disable({ emitEvent: false });
            c.get('Benefiaddr').disable({ emitEvent: false });
            c.get('accountNwt').disable({ emitEvent: false });
            c.get('swiftbankcode').disable({ emitEvent: false });
        
            c.get('Benefiname').clearValidators();
            c.get('Benefiaddr').clearValidators();
            c.get('accountNwt').clearValidators();
            c.get('swiftbankcode').clearValidators();
          }
          break;
  
          case 'WT_DOMESTIC':
            if (this.WTDOME === 'manual') {
              c.get('Benefinamewtdome').enable({ emitEvent: false });
              c.get('Benefiaddrwtdome').enable({ emitEvent: false });
              c.get('accountNwtdo').enable({ emitEvent: false });
              c.get('routingnumberwtdo').enable({ emitEvent: false });
          
              c.get('Benefinamewtdome').setValidators([Validators.required]);
              c.get('Benefiaddrwtdome').setValidators([Validators.required]);
              c.get('accountNwtdo').setValidators([Validators.required]);
              c.get('routingnumberwtdo').setValidators([Validators.required]);
            } else {
              c.get('Benefinamewtdome').disable({ emitEvent: false });
              c.get('Benefiaddrwtdome').disable({ emitEvent: false });
              c.get('accountNwtdo').disable({ emitEvent: false });
              c.get('routingnumberwtdo').disable({ emitEvent: false });
          
              c.get('Benefinamewtdome').clearValidators();
              c.get('Benefiaddrwtdome').clearValidators();
              c.get('accountNwtdo').clearValidators();
              c.get('routingnumberwtdo').clearValidators();
            }
            break;
  
      case 'PAYPAL':
        c.get('emailpaypal').enable({ emitEvent: false });
        c.get('emailpaypal').setValidators([Validators.required, Validators.email]);
        break;
  
      case 'CREDIT_CARD':
        c.get('ARdepartament').enable({ emitEvent: false });
        c.get('phonecredit').enable({ emitEvent: false });
        c.get('deparmentAR').enable({ emitEvent: false });
        c.get('ARdepartament').setValidators([Validators.required]);
        c.get('phonecredit').setValidators([Validators.required]);
        c.get('deparmentAR').setValidators([Validators.required, Validators.email]);
        break;
    }
  
  
  /*   dynamicFields.concat(['paymentAmount','paymentUrgency'])
      .forEach(name => {
        const ctrl = c.get(name);
        if (ctrl) ctrl.updateValueAndValidity({ emitEvent: false });
      }); */
      dynamicFields.concat(['paymentAmount','paymentUrgency','pickupDate','invoiceNumber'])
      .forEach(name => {
        const ctrl = c.get(name);
        if (ctrl) ctrl.updateValueAndValidity({ emitEvent: false });
      });
    this.checks.controls.forEach(group => {
      group.get('payableTo').updateValueAndValidity({ emitEvent: false });
      group.get('amount').updateValueAndValidity({ emitEvent: false });
    });
   
  }
  

  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
  public filterrigh = "";
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
    

   this.getlistpo();
  }
  updateConfig(e) {
    this.options = e;
   
    this._config.setConfig('popayment', this.options).subscribe(
      r => {
        

      }
    );
  }
  ngAfterViewInit() {
    
    setTimeout(() => this.onMethodTabChange(0), 0);
  }
  private safeFormatDate(d: Date|null): string|null {
    return (d instanceof Date) ? this.formatDate(d) : null;
  }
  
  private safeFormatDateTime(d: Date|null): string|null {
    return (d instanceof Date) ? this.formatDateTime(d) : null;
  }
  allSelectedPoAmountsValid(): boolean {
    if (!this.bulk.length) return false;
    const total = this.bulk.reduce((sum, poId) => {
      const po = this.allRows[poId];
      return sum + (po ? Number(po.originalTotalCostPo) : 0);
    }, 0);
    return total > 0;
  }

  
  handleNextStep() {
  console.log("thistest")
  console.log(this.step4Control.errors)
  console.log(this.selectedMethodType)
  console.log('Form Values:', this.step4Control.value); 
  console.log('Form Valid:', this.step4Control.valid);
  /* console.log(this.step4Control.controls) */
  console.log("thistest")


  }

  isFileRequiredButNotUploaded(): boolean {
   
    if (this.selectedMethodType === 'ACH_DOMESTIC' && this.modeACH === 'file' && this.filesCount === 0) {
      return true;
    }
   
    if (this.selectedMethodType === 'WT_INTERNATIONAL' && this.WTINTER === 'file' && this.filesCount === 0) {
      return true;
    }
   
    if (this.selectedMethodType === 'WT_DOMESTIC' && this.WTDOME === 'file' && this.filesCount === 0) {
      return true;
    }
    return false;
  }

  setModeACH(mode: 'manual' | 'file') {
    this.modeACH = mode;
    this.updateMethodValidators();
    this.step4Control.updateValueAndValidity();
  }
  
  setWTIN(mode: 'manual' | 'file') {
    this.WTINTER = mode;
    this.updateMethodValidators();
    this.step4Control.updateValueAndValidity();
  }
  
  setWTDOME(mode: 'manual' | 'file') {
    this.WTDOME = mode;
    this.updateMethodValidators();
    this.step4Control.updateValueAndValidity();
  }

  onAmountChanged(event: any) {
    const value = Number(event.target.value);
    const max = this.numericBulkTotal; 
    if (value > max && this.selectedPaymentType === 'PO') {
      this.showAmountError = true;
    } else {
      this.showAmountError = false;
    }
  }
  

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    let anio = fecha.getFullYear();

    return anio + "-" + month + "-" + day;
  }
}
